import React from 'react';
import Typography from '@lib/components/Typography/Typography';
import UserPreview from '@lib/components/UserPreview/UserPreview';
import { getFormattedDate } from '@lib/utils/dateTimeHelpers';
import { dateTimeFormatEU } from '@lib/enums/dateTime';
import styles from './HistoryCard.module.scss';

interface HistoryCardProps {
  actionLabel: string;
  avatarUrl?: string | null;
  children?: React.ReactNode;
  date: string;
  indentBody?: boolean;
  userName: string;
}

export default function HistoryCard({
  actionLabel,
  avatarUrl,
  children,
  date,
  indentBody = true,
  userName,
}: HistoryCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <UserPreview avatarUrl={avatarUrl} userName={userName} />
        <div className={styles.headerMeta}>
          <Typography variant="caption" className={styles.actionLabel}>
            {actionLabel}
          </Typography>
          <span className={styles.divider} />
          <Typography variant="caption" className={styles.date}>
            {getFormattedDate(date, dateTimeFormatEU)}
          </Typography>
        </div>
      </div>
      {children && (
        <>
          <div className={styles.separator} />
          <div className={indentBody ? styles.bodyIndented : styles.body}>
            {children}
          </div>
        </>
      )}
    </div>
  );
}
